import { Component, ViewChild, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit, ChangeDetectorRef, SimpleChanges, TemplateRef, ElementRef, Inject } from '@angular/core';
import { LoaderService } from '../../shared/loader/loader.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { Observable, Subscription } from 'rxjs';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { MatRadioChange } from '@angular/material/radio';
export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}
@Component({
  selector: 'app-FormReports3CMap',
  templateUrl: './FormReports3CMap.component.html',
  styleUrls: ['./FormReports3CMap.component.scss'] 
})

export class AddFormReports3CMapComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  formDialog: FormGroup;   
  formfoldername:string="";
  disabledUpdate:boolean=true;
  spinner:boolean=false;
  successUrl:string="";
  declineUrl:string="";
  formFolderID:number=0;
  OfficeIDList: any = [];
  myOfficeID: any;
  menuModulesList: any = [] = [];
  stateCtrlValue: string;
  objectList: any = [];
  filteredStates: Observable<State[]>;
  timeout = null;

  CoreShowName: string = "";
  ContactShowName: string = "";

  stateCtrl = new FormControl();

  ShowAttchedToCore: boolean = true;
  ShowAttchedToContact: boolean = false;

  attachedToCoreList: any = [] = [];
  attachedToContactList: any = [] = [];
  
  attachedToSelectedCore: any = [] = [];
  attachedToSelectedContact: any = [] = [];
 
  CorefolderID: number = 0;
  ContactfolderID: number = 0;

  roleIdList: any = [];

  checkedAttachCore: boolean = true;
  checkedAttachContact: boolean = false;
  showSaveButton:boolean=true;
  cType:number=1;
  cid:number=0;
  showMessage:boolean=false;

  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<AddFormReports3CMapComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private statusConst: StatusConstant,
    private formService: FormsService,private toastr: ToastrService,private statusConstant: StatusConstant,
    private loaderService: LoaderService,) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
    this.currentUser = jwt_decode(token); 
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });

    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''), map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );

  }  
  
  ngOnInit(): void {
    this.data;  
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore = [];
    var SelectedContact = [];
    
    SelectedCore = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
    }

    SelectedContact = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Contact');
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;
    } 
    this.attachedToSelectedCore=[];
    this.attachedToSelectedContact=[];
    this.showSaveButton=true;
    this.cid=0;
    this.cType=1;  //1 Core,  2 Contact , 3 Company     
    if(this.data.email!=""){
      this.stateCtrl.setValue(this.data.email);
      this.getsearchCoreOnLoad(this.data.email);
    }
  }     
    
  states = this.objectList;

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }
  

  selectCCC($event: MatRadioChange) {
    this.showMessage=false;
    this.stateCtrl.reset();
    if ($event.value === 'Core') {

      this.cType=1;

      this.ShowAttchedToCore = true;
      this.ShowAttchedToContact = false;      

      this.checkedAttachCore = true;
      this.checkedAttachContact = false;      
     
    }
    if ($event.value === 'Contact') {
      this.cType=2;

      this.ShowAttchedToCore = false;
      this.ShowAttchedToContact = true;     

      this.checkedAttachCore = false;
      this.checkedAttachContact = true;   
    }   
   
    this.attachedToSelectedCore=[];
    this.attachedToSelectedContact=[];
    this.showSaveButton=true;
  }


  getsearchCoreOnLoad(searchValue: any) {
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.formService.searchCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCoreList = response.data;
          if(this.attachedToCoreList.length>0){
            var checkCore = [];
            var coreSelected = this.attachedToCoreList[0];
            this.stateCtrl.setValue('');
            checkCore = this.attachedToSelectedCore;
            if (checkCore.length == 0) {
              var shortName = "";
              shortName = coreSelected.name.match(/\b(\w)/g).join('');
              var ReqModel = {        
                coreID: coreSelected.coreID,
                email: coreSelected.email,
                name: coreSelected.name,      
                transactionID: coreSelected.transactionID,
                img: coreSelected.imageUrl,
                typeID: coreSelected.typeID,
                isDeleted: false,
                shortName: shortName,
              }
              this.attachedToSelectedCore.unshift(ReqModel);
              this.stateCtrl.reset();
              if (this.attachedToSelectedCore.length > 0) {
                this.showSaveButton = false;
                this.showMessage=false;
              } else {
                this.showSaveButton = true;
                this.showMessage=true;
              }  
             
           }
          }else{
            this.showMessage=true;
          }
        } else {
          this.attachedToCoreList = [];
          this.showMessage=true;
        }
      }else{
        this.showMessage=true;
      }
    })
  }

  //======================Core============================//

  searchCore(val) {
    if (val.length >= 2) {
      this.attachedToCoreList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCore(val)
        }, 500);
      } else {
        this.attachedToCoreList = [];
      }
    }
  }

  getsearchCore(searchValue: any) {
    var SelectedCCC = [];
    SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.formService.searchCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCoreList = response.data;

        } else {
          this.attachedToCoreList = [];
        }
      }
    })
  }


  attchedToCoreSelected(coreSelected: any) {
    var checkCore = [];
    this.stateCtrl.setValue('');
    checkCore = this.attachedToSelectedCore;//.filter((x:any) => x.isDeleted == false);
    if (checkCore.length == 0) {
      var shortName = "";
      shortName = coreSelected.name.match(/\b(\w)/g).join('');
      var ReqModel = {        
        coreID: coreSelected.coreID,
        email: coreSelected.email,
        name: coreSelected.name,      
        transactionID: coreSelected.transactionID,
        img: coreSelected.imageUrl,
        //typeID: coreSelected.typeID,        
        shortName: shortName,
      }
      this.attachedToSelectedCore.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.attachedToSelectedCore.length > 0) {
        this.showSaveButton = false;
        this.showMessage=false;
      } else {
        this.showSaveButton = true;
        this.showMessage=true;
      }  
     
    }
 
  }

  attchedToRemoveCore(item: any) {
     const index = this.attachedToSelectedCore.indexOf(item);
      if (index >= 0) {
        this.attachedToSelectedCore.splice(index, 1);
      }
      if (this.attachedToSelectedCore.length > 0) {
        this.showSaveButton = false;
      }
      if (this.attachedToSelectedCore.length == 0) {
        this.showSaveButton = true;
        this.stateCtrl.reset();
      }  
  }


   //======================Contact============================//

  searchContacts(val) {
    if (val.length >= 2) {
      this.attachedToContactList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchContact(val)
        }, 500);
      } else {
        this.attachedToContactList = [];
      }
    }
  }

  getsearchContact(searchValue: any) {
    var SelectedCCC = [];

    SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Contact');
    if (SelectedCCC.length > 0) {
      this.ContactfolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.ContactfolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.formService.searchContact(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToContactList = response.data;

        } else {
          this.attachedToContactList = [];
        }
      }
    })
  }


  attchedToContactSelected(contactSelected: any) {
    var checkContact = [];
    this.stateCtrl.setValue('');
    checkContact = this.attachedToSelectedContact;//.filter((x:any) => x.isDeleted == false);
    if (checkContact.length == 0) {
      var shortName = "";
      shortName = contactSelected.name.match(/\b(\w)/g).join('');
      var ReqModel = {      
        contactID: contactSelected.contactID,
        email: contactSelected.email,
        name: contactSelected.name,      
        transactionID: contactSelected.transactionID,
        img: contactSelected.imageUrl,
        //typeID: contactSelected.typeID,       
        shortName: shortName,
      }
      this.attachedToSelectedContact.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.attachedToSelectedContact.length > 0) {
        this.showSaveButton = false;
      } else {
        this.showSaveButton = true;
      }
  }
  
  }


  attchedToRemoveContact(item: any) {
    const index = this.attachedToSelectedContact.indexOf(item);
      if (index >= 0) {
        this.attachedToSelectedContact.splice(index, 1);
      }
      if (this.attachedToSelectedContact.length > 0) {
        this.showSaveButton = false;
      }
      if (this.attachedToSelectedContact.length == 0) {
        this.showSaveButton = true;
        this.stateCtrl.reset();
      }    
  }


  addUpdateFolderUrl() {
    this.data;
   if(this.cType==1){
     if(this.attachedToSelectedCore.length>0){
        this.cid=this.attachedToSelectedCore[0].coreID;
      }
    }
   if(this.cType==2){
      if(this.attachedToSelectedContact.length>0){
        this.cid=this.attachedToSelectedContact[0].contactID;
      }
    }
    var ReqModel = {
      projectID: Number(this.data.projectID),
      pType:Number(this.data.pType),
      formID: Number(this.data.formID),
      cid: Number(this.cid),
      cType: Number(this.cType),  //1 Core,  2 Contact , 3 Company     
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.spinner=true;
    this.showSaveButton=true;
    this.formService.mapCoreContactWithFinalDocuments(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        this.spinner=false;   
        if(this.responseHolder.status == this.statusConst.statusSuccess) { 
          this.toastr.success('Documents map successfully selected record.', '', {
           timeOut: 3000,
          });
          this.dialogRef.close('Added');
          //this.close();
        } else {   
          this.loaderService.hide();
          this.spinner=false;     
        }
      }
    })
  } 

 close() { 
  this.dialog.closeAll();
 }


  
}
